import { useReducer, useEffect, useRef } from 'react'

function useReducerWithCallback (reducer, initialState) {
  const [state, originalDispatch] = useReducer(reducer, initialState)
  const callbackRef = useRef(null)

  const dispatch = (action, callback) => {
    originalDispatch(action)
    callbackRef.current = callback
  }

  useEffect(() => {
    const callback = callbackRef.current

    if (typeof callback === 'function') {
      callback(state)

      callbackRef.current = null
    }
  }, [state])

  return [state, dispatch]
}

export default useReducerWithCallback
